<div *ngIf="ShowModalHeader" class="glb_headerBarBGDark glb_customFlexRow justify-content-end col-12" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    <div class="justify-content-start align-self-bottom">
        <button id="BTN_CloseCustomerVerification" tabindex="30"
            class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
            (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
            <fa-icon [icon]="['fal', 'times']" class="fa-md glb_iconColorDark"></fa-icon>
        </button>
    </div>
</div>
<div id="PG_ConfirmModal" class="glb_formBGColor glb_boxedPadding">
    <div class="text-white">
        <p class="glb_Font">{{message}}</p>
        <div class="glb_Font" [innerHtml]="htmlContent | sanitizeHtml"></div>
    </div>
    <br>
    <div *ngIf="ShowYesButton" class="glb_paddingTopSM glb_customFlexRow row-cols-1 justify-content-center align-items-center">
        <div class="glb_paddingBottomSM d-grid">
            <button id="BTN_ConfirmPageYes" tabindex="13" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                [mat-dialog-close]="true">
                <span class="glb_Font glb_smallerText">{{YesButtonText}}</span></button>
        </div>
        <div *ngIf="ShowNoButton" class="glb_paddingBottomSM d-grid">
            <button id="BTN_ConfirmPageNo" tabindex="13" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                (click)="onNoClick()" cdkFocusInitial>
                <span class="glb_Font glb_smallerText">No</span></button>
        </div>
    </div>
</div>